import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type SaleSmartlyProps = Omit<BusinessIconImageProps, 'color' | 'strokeWidth'>;

const SaleSmartly = forwardRef<SVGSVGElement, SaleSmartlyProps>(
  ({ size = 24, width, height, alt = '', style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={style}
      {...props}
    >
      <g transform="matrix(0.31428571 0 0 0.31428571 -0.57142840 0.37142873)">
        <path fill="#2E4FED" d="M39.6 6L41.1 8.1L39.2 10.1L42.8 11.8L43 13.8L37 17L38.2 13.2L36.2 10L38.7 7.8L38.1 6.8L39.6 6Z" />
        <path fill="#2E4FED" fillRule="evenodd" clipRule="evenodd" d="M24 20.5H35.5V18H43.5V20.5H56C63.7 20.5 69 27.8 69 36V47.5C69 56.2 62.2 63 53.5 63H38L31.3 68C30.4 68.6 29 68 29 66.8V63H25.5C17.2 63 11 56.4 11 48V35.5C11 27.2 17.2 20.5 24 20.5ZM27 28H37.2L38.2 25H41.2L42.2 28H53C58 28 61 32.2 61 37V46C61 51 58 55 53 55H27C22 55 19 51 19 46V37C19 32.2 22 28 27 28Z" />
        <rect x="8.5" y="39.5" width="63" height="4" fill="white" />
        <path fill="#2E4FED" d="M9.5 32.5C6.4 33.8 5 36.4 5 40.5C5 44.7 6.5 47.6 9.5 49.2V32.5Z" />
        <path fill="#2E4FED" d="M70.5 32.5C73.6 33.8 75 36.4 75 40.5C75 44.7 73.5 47.6 70.5 49.2V32.5Z" />
        <circle cx="30" cy="41" r="4" fill="#5CCCBE" />
        <circle cx="49" cy="41" r="4" fill="#5CCCBE" />
      </g>
    </svg>
  ),
);

SaleSmartly.displayName = 'SaleSmartly';

export default SaleSmartly;
